<div class="row filter-type-selection-header">
  <div class="col-12">BvD Independence Indicator</div>
</div>
<div class="row filter-type-selection-body">
  <div class="col-12">
    <p-treeTable
      [value]="bvdIndependence"
      (click)="formDirty = true"
      selectionMode="checkbox"
      [(selection)]="filter.bvdIndependence"
      (onRowSelect)="sortSelection(filter.bvdIndependence)"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="first-column" colspan="2">Select the companies with a given "BvD Independence Indicator"</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
        <tr>
          <td class="first-column" [attr.colspan]="rowData.columns ? rowData.columns : 1">
            <p-treeTableCheckbox (click)="formDirty = true" [value]="rowNode" [disabled]="readOnly"></p-treeTableCheckbox>
            {{ rowData.name }}
          </td>
          <td class="first-column" *ngIf="rowData.heading" [attr.rowspan]="rowData.rows">
            <span [innerHtml]="rowData.heading"></span>
          </td>
        </tr>
      </ng-template>
    </p-treeTable>
    <div class="row">
      <div class="col=12">
        <span class="help-block">
          <input type="hidden" [(ngModel)]="filter.bvdIndependence" name="bvdIndependencefield" #bvdIndependencefield="ngModel" required />
          <span *ngIf="formDirty && bvdIndependencefield.invalid"> Please select an option </span>
        </span>
      </div>
    </div>
  </div>
</div>
